'use client';

import { useCallback, useRef } from 'react';

// Backend integration point: replace with actual audio files at /public/sounds/
const SOUND_URLS: Record<string, string> = {
  click: '/sounds/click.mp3',
  hover: '/sounds/hover.mp3',
  success: '/sounds/success.mp3',
};

export function useSound() {
  const audioCache = useRef<Record<string, HTMLAudioElement>>({});

  const play = useCallback((soundName: keyof typeof SOUND_URLS) => {
    try {
      const url = SOUND_URLS[soundName];
      if (!url) return;

      if (!audioCache.current[soundName]) {
        const audio = new Audio(url);
        audio.volume = 0.3;
        audioCache.current[soundName] = audio;
      }

      const audio = audioCache.current[soundName];
      audio.currentTime = 0;
      audio.play().catch(() => {
        // Sound playback failed silently — user interaction required
      });
    } catch {
      // Silently fail — sounds are enhancement only
    }
  }, []);

  return { play };
}